"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.termsAndConditions = exports.privacyPolicy = exports["default"] = void 0;
var selectFieldOptions = _interopRequireWildcard(require("./selectFieldOptions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var phoneNumbers = {
  'Orion': {
    northAmerica: '1-888-997-0152',
    international: '1-519-251-0152'
  },
  'La Capitale': {
    northAmerica: '1-855-747-7764',
    international: '1-418-747-7714'
  },
  'Empire': {
    northAmerica: '1-800-321-9998',
    international: '1-519-742-2800'
  },
  'AIG': {
    northAmerica: '1-877-204-2017',
    international: '1-715-295-9962'
  },
  'HumanaCare': {
    number: '1-800-661-8193'
  },
  'Assure': {
    number: '1-800-668-1608'
  },
  simplyBenefits: {
    canadaUSA: '1-877-815-7751',
    // our simply phone number
    support: '+18778157751',
    international: '1-519-251-0152'
  }
};
var memberStatusMap = {
  0: 'Pending',
  1: 'Active',
  2: 'Disabled',
  3: 'Parental Leave',
  4: 'Leave of Absence',
  5: 'Temporary Lay Off',
  6: 'Disability',
  7: 'Strike',
  8: 'Late Applicant',
  9: 'Terminated',
  10: 'Approved Leave',
  Pending: 0,
  Active: 1,
  Disabled: 2,
  'Parental Leave': 3,
  'Leave of Absence': 4,
  'Temporary Lay Off': 5,
  Disability: 6,
  Strike: 7,
  'Late Applicant': 8,
  Terminated: 9,
  'Approved Leave': 10
};
var accountStatusMap = {
  0: 'In Progress',
  1: 'Active',
  2: 'Disabled',
  3: 'Under Revisions',
  9: 'Cancelled',
  'In Progress': 0,
  Active: 1,
  Disabled: 2,
  'Under Revisions': 3,
  Cancelled: 9
};
var accountStateMap = {
  0: 'Census',
  1: 'Account History',
  2: 'Plan Design',
  3: 'Commissions',
  4: 'Master Application',
  5: 'Pending Underwriting',
  6: 'Under Review',
  7: 'Plan Assignment',
  8: 'Request Approval',
  9: 'Approved',
  10: 'Active',
  'Census': 0,
  'Account History': 1,
  'Plan Design': 2,
  'Commissions': 3,
  'Master Application': 4,
  'Pending Underwriting': 5,
  'Under Review': 6,
  'Plan Assignment': 7,
  'Request Approval': 8,
  'Approved': 9,
  'Active': 10
};
var advisorStatusMap = {
  1: 'Active',
  2: 'Disabled',
  9: 'Cancelled',
  Active: 1,
  Disabled: 2,
  Cancelled: 9
};
var categoryMap = {
  chiropractor: 'Chiropractor',
  deathDismemberment: 'Death & Dismemberment',
  dental: 'Dental',
  dependentLife: 'Dependent Life',
  drugs: 'Drugs',
  hearing: 'Hearing Aids',
  lifeInsurance: 'Life Insurance',
  massage: 'Massage',
  naturopath: 'Naturopath',
  orthotics: 'Orthothics',
  osteopath: 'Osteopath',
  physiotherapy: 'Physiotherapy',
  podiatrist: 'Podiatrist',
  psychologist: 'psychologist',
  speech: 'Speech Therapy',
  vision: 'Vision'
};
var simplyInfo = {
  adminEmail: 'administration@simplybenefits.ca',
  supportEmail: 'support@simplybenefits.ca',
  contactEmail: 'contact@simplybenefits.ca',
  claimsEmail: 'claims@simplybenefits.ca',
  simplyAddress: '601-460 Doyle Ave Kelowna BC, V1Y 0C2',
  publicSiteUrl: 'simplybenefits.ca',
  appStore: 'https://apps.apple.com/us/app/simply-benefits/id1494221810',
  playStore: 'https://play.google.com/store/apps/details?id=com.simplybenefits.app&hl=en_CA'
};
var termsAndConditions = exports.termsAndConditions = "Simply Benefits Inc. (\u201Cus\u201D, \u201Cwe\u201D, or \u201CSimply Benefits\u201D) is committed to privacy and the protection of your information. By using Simply Benefits\u2019s website, mobile and other applications, and related Services made available through the Apple App Store, the Google PLAY Store, or otherwise on the Internet (together, the \u201CSimply Benefits Applications\u201D or \u201CApplications\u201D), you acknowledge that you accept the practices and policies outlined in this Privacy Policy (\u201CPrivacy Policy\u201C). Unless otherwise defined herein, capitalized terms shall have the meanings assigned to such terms set forth in the Terms of Service and which incorporate this Privacy Policy by reference.";
var privacyPolicy = exports.privacyPolicy = "At Simply Benefits Corp (\"Simply Benefits\") we are concerned with safeguarding and protecting the privacy of your personal information. In accordance with Canada's *Personal Information Protection & Electronic Documents Act* (\"PIPEDA\") we have established policies on how we collect, use and protect any information that you give us when you use our website or services.\n\nWhat We Collect\nRequired Regulatory Information\nSimply Benefits collects information needed to provide services and meet the regulatory requirements of our industry. When you open an account or sign up for services, we collect personal information which may include but is not limited to the following:\n\nYour name and date of birth\nContact details\nNature of your employment or business\nDetails about your dependents\nDemographics\nOther information relevant to the services we provide\nPassive Data Collection\nWe may receive passively-collected information through a variety of methods, including \u201Ccookies\u201D to collect information.\n\nWhat is a cookie?\n\nCookies are text files containing small amounts of information which are downloaded to your device when you visit a website. Cookies are then sent back to the originating website on each subsequent visit, or to another website that recognizes that cookie. You can get more information about cookies here.\n\nSimply Benefits uses cookies to track and measure site performance and gather analytics on usage. This information is anonymous and is only used by Simply Benefits to measure and improve our site.\n\nWhen sending e-mail we may use tracking pixels and urls to help us measure open rates for e-mails and link clicks. This tracking information is used internally only to help us provide relevant content and is never shared with any third parties.\n\nOpting Out of Cookies\n\nIf you choose, you may set your browser to notify you when you receive a cookie, giving you the chance to decide whether or not to accept it.\n\nAnalytics And Marketing\n\nWe use analytics tools and other third party technologies, such as Google Analytics, to collect non-personal information in the form of various usage and user metrics when you use our online Sites and/or Services.\n\nWe also use online advertising to reach new potential clients and remarketing tools that allow us to target ads to specific groups of people who have previously interacted with WealthBar\u2019s websites.\n\nGoogle allows individuals to opt out of it\u2019s advertising cookies from its ad settings page.\n\nGoogle has additional information available about their Remarketing Privacy Guidelines, and Restrictions.\n\nWhere do we store it\nSimply Benefits may use third parties to store and process data. Simply Benefits will ensure that such third party service providers have significant expertise with data and digital privacy. Simply Benefits will ensure that personal data is stored and transmitted in encrypted format using technology such as SSL. Third party data storage and processing providers may be located in the United States and as a result personal information may be subject to U.S. privacy law which may differ from Canadian privacy law.\n\nHow We Use It\nThe information we collect is used so we can communicate with you, provide benefits and insurance management services, improve our products and services, and meet our regulatory obligations.\n\nWe share only the information which is reasonably required in the normal course of business with third parties such as our custodians, securities regulators, auditors, legal counsel, or law enforcement agencies, to enable them to fulfill their obligations to Simply Benefits and our clients. We may also disclose your personal information to third-party service providers, affiliates and agents in order to assist us in providing the services you requested and to fulfil the purposes for which your personal information has been collected. Outside of this we shall not sell, distribute or lease your personal information to third parties unless we have your permission or are required by law to do so.\n\nHow We Protect It\nWe are committed to ensuring that your information is secure. In order to prevent unauthorized access or disclosure, we have put in place suitable physical, electronic and managerial procedures to safeguard and secure the information we collect online. In the event that we share your personal information with third-party service providers, affiliates and agents, these parties will be required to adhere to strict confidentiality obligations and practices.\n\nIf you have a question, concern or complaint about our privacy policy, please send your comments and your contact details to our Privacy Officer in writing to the following address:\n\nSimply Benefits Corp. 601-460 Doyle Ave Kelowna BC, V1Y 0C2\n\nproduct@simplybenefits.ca\n\nIf you believe that any information we have on file for you is incorrect or incomplete, please write to or email us as soon as possible, at the above address. We will promptly correct any information found to be incorrect.";
var _default = exports["default"] = {
  phoneNumbers: phoneNumbers,
  memberStatusMap: memberStatusMap,
  accountStatusMap: accountStatusMap,
  accountStateMap: accountStateMap,
  advisorStatusMap: advisorStatusMap,
  simplyInfo: simplyInfo,
  categoryMap: categoryMap,
  termsAndConditions: termsAndConditions,
  privacyPolicy: privacyPolicy,
  selectFieldOptions: selectFieldOptions
};